import { Box, } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';

const Loader = () => <Box display='flex' justifyContent='center' alignItems='center' height='70vh'> <CircularProgress /> </Box>
   

export default Loader;